<template>
  <div class="filters-wrapper">
    <div class="filter-wrapper">
      <div class="filter-title">
        {{ __("frontend_js.stores.search_trademark_city") }}
      </div>
    </div>
    <ul class="filter-categories">
      <store-filter
        :title="__('frontend_js.category.filter.trademark')"
        data-key="trademarks"
      />
      <store-filter :title="__('frontend_js.category.filter.city')" data-key="cities" />
    </ul>

    <store-active-filters />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    storesForFilter: { required: true },
    filterData: { required: true },
  },

  data() {
    return {
      filters: null,
      urlPath: "",
    };
  },
  computed: {
    ...mapGetters("store-filters", ["queryFilters"]),
  },
  created() {
    this.urlPath = window.location.pathname.split("/")[1];

    this.$store.commit("store-filters/SET_FILTER_DATA", this.filterData);
    this.$store.commit("store-filters/SET_STORES", this.storesForFilter);

    this.$store.commit("store-filters/SET_FILTERS");

    this.$root.$on("filterChanged", this.filterChanged);

    window.addEventListener("popstate", (event) => {
      this.$store.commit("store-filters/SET_FILTERS");
    });
  },
  methods: {
    async filterChanged() {
      let queryString = this.queryFilters ? "/f/" + this.queryFilters : "";

      window.history.pushState(null, null, "/" + this.urlPath + queryString);
    },
  },
};
</script>

<style lang="scss" scoped></style>
